export const DISCUSS_FORUM_URL = "https://discuss.layer5.io/";